module.exports = __webpack_public_path__ + "media/images/visa-2-d4fe171107a8b2435254dbf420f6738a.png";